/**
 * @generated SignedSource<<37ab2e117a86d1dc715949d29203f432>>
 * @relayHash b9a37f70969ec1ccfea09d42d23ee047
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f211597d24101c497aaa6a30088a1b2c297fbb6197c83adc7a00aafa186acb5f

import type { ConcreteRequest } from 'relay-runtime';
export type SpaceNameQuery$variables = {
  spaceKey: string;
};
export type SpaceNameQuery$data = {
  readonly space: {
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
};
export type SpaceNameQuery = {
  response: SpaceNameQuery$data;
  variables: SpaceNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceNameQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceNameQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b9a37f70969ec1ccfea09d42d23ee047",
    "id": "f211597d24101c497aaa6a30088a1b2c297fbb6197c83adc7a00aafa186acb5f",
    "metadata": {},
    "name": "SpaceNameQuery",
    "operationKind": "query",
    "text": "query SpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id,name,key}}"
  }
};
})();

(node as any).hash = "0ef458e46db525bf3a5156fbd23b8cfc";

export default node;
